<template>
  <!-- prettier-ignore -->
  <div
    class="product"
    cy-section="product-upselling"
  >
    <span
      @click="openPreview"
      v-html="upsellLabel"></span>

    <ovp-button
      class="product__btn"
      secondary
      tiny
      @click="add">
      <template v-if="isUpgrade">
        {{ $t('product.actions.add') }}
      </template>
      <template v-else>
        {{ $t('product.actions.replace') }}
      </template>
    </ovp-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { EVENT_PRODUCT_DETAIL_OPEN, SOURCE_UPSELLING } from '@/config/events'

import BasketMixin from '@/mixins/Basket'

export default {
  name: 'UpsellProduct',

  mixins: [BasketMixin],

  props: {
    categoryId: {
      type: String,
      required: true,
    },

    personId: {
      type: String,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },

    upsellProduct: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isUpgrade() {
      return this.product?.upgrades?.includes(this.upsellProduct.id) || false
    },

    mode() {
      return this.isUpgrade ? 'ADD' : 'REPLACE'
    },

    price() {
      if (this.isUpgrade) {
        return this.upsellProduct.price.price.toFixed(2)
      } else {
        const original = this.product.price.price
        return parseFloat(this.upsellProduct.price.price - original).toFixed(2)
      }
    },

    upsellLabel() {
      const product = this.$t('content.products')[this.upsellProduct.id].name
      let price = this.price
      const positive = price >= 0
      const labelKey = positive ? 'positive' : 'negative'

      if (!positive) {
        price = Math.abs(price).toFixed(2)
      }

      return this.$t(`product.upselling.${labelKey}`, {
        price,
        product: `<a class="product__link" href="">${product}</a>`,
      })
    },
  },

  methods: {
    ...mapActions('basket', ['setBasket']),

    add() {
      const payload = {
        productId: this.upsellProduct.id,
        personId: this.personId,
        categoryId: this.categoryId,
        mode: this.mode,
        source: SOURCE_UPSELLING
      }
      this.$emit('added', payload)
    },

    openPreview(event) {
      event.preventDefault()

      if (event.target.tagName === 'A') {
        this.$emit('open')
        this.$EventBus.$emit(EVENT_PRODUCT_DETAIL_OPEN, {
          categoryId: this.categoryId,
          productId: this.upsellProduct.id,
          type: this.type,
          source: SOURCE_UPSELLING,
        })
      }
    },
  },
}
</script>

<style name="mobile" scoped>
.product {
  &__link {
    color: var(--c-original-green);
    font-size: 15px;
  }

  &__btn {
    margin-left: 5px;
  }
}
</style>
